import {z, ZodOptional, ZodType} from "zod/v4";
import {SheetProps} from "@mui/joy";
import * as z4 from "zod/v4/core";
import {objectKeys} from "./arutil.tsx";

// export const ReactNode: z.ZodType<ReactNode> = z.any();

export const JoyColor: z.ZodType<SheetProps["color"]> = z.any();

// export const T: z.ZodType<TFunction> = z.any();

export type ValuesOf<T> = T[keyof T];

export type Zoddable = Readonly<{
    [k: string]: z4.$ZodType<unknown, unknown, z4.$ZodTypeInternals>;
}>

export function isZodOptional<T extends ZodType>(maybe: T | ZodOptional<T>): maybe is ZodOptional<T> {
    return !!maybe._zod.optin;
}

export function getLoneKey(pkg: Record<PropertyKey, unknown>): PropertyKey | undefined {
    const keys = Object.keys(pkg);
    if (keys.length === 1) {
        return keys[0];
    }
}

export type SealedLetter<Envelope extends PropertyKey, LetterT> = Record<Envelope, LetterT>;

export function replaceLetter<const Envelope extends PropertyKey, const LetterT>(orig: SealedLetter<Envelope, LetterT>, nv: LetterT): SealedLetter<Envelope, LetterT> {
    const k0 = objectKeys(orig)[0];
    const rv = Object.fromEntries([[k0, nv]]) as SealedLetter<Envelope, LetterT>;
    return rv;
}

